document.addEventListener('DOMContentLoaded', () => {
  const modelCards = document.querySelectorAll('.model-card .model-card__subtitle')
  if(modelCards) {
    modelCards.forEach(card => {
      const href = card.getAttribute('data-href')
      if(href) {
        card.addEventListener('click', e => {
          e.preventDefault()
          window.location.href = href
        })
      }
    })
  }



})